if(collectioTitle === "Products") {
  collectioTitle = "*:*";
} else {
  if(collectioTitle.indexOf("-")) {
    collectioTitle = collectioTitle.replace(/-/g, '/');
  }
  
  if(collectioQuery) {
    const collectionQueryArray = collectioQuery.split("|");
    const catQueryArray = collectionQueryArray[0].split(":");
    collectioTitle = catQueryArray[0].trim() + ':"' + catQueryArray[1].trim() + '"';
    if(collectionQueryArray.length > 1) {
      const subCatQueryArray = collectionQueryArray[1].split(":");
      if(subCatQueryArray.length > 0) {
        collectioTitle = collectioTitle + ' AND ' + subCatQueryArray[0].trim() + ':"' + subCatQueryArray[1].trim() + '"';
      }
    }
  } else {
    collectioTitle = 'product_type:"' + collectioTitle+ '"';
  }
}
collectioTitle = encodeURI(collectioTitle);
var productPerPage = 12;
var totalResults;
var currentstart = 0;
var currentrows = productPerPage;
var sortOption = "total_inventory%20desc";
var selectedFields = new Map();
var baseProductUrl = serviceUrl + "/search?q=productEnabled:true AND "+collectioTitle+"&start="+currentstart +"&rows=" + currentrows + "&sort=total_inventory%20desc&facet.sort=index";
var filterProductUrl = serviceUrl + "/search?q="+collectioTitle+"&fq=meta-product-color:cape&start="+currentstart+"&rows="+currentrows + "&facet.sort=index";
var filteredResults;
function sortProducts(sort){
sortOption = sort.value;
fetchSearchResults();
}

function getFilterProducts(productUrl){
  $.ajax({
      type: 'GET',
      url: productUrl,
      dataType: 'json',
      success: function(res){
          //filterProducts(res.response.docs, tag)
          filteredResults = res.response.docs;
          buildFilteredProducts(filteredResults);
          if(res.hasOwnProperty('facet_counts')) {
            buildFacetForProducts(res.facet_counts.facet_fields, res.facet_counts.facet_intervals, res.response.numFound);
          }
          buildPagination(res.response.numFound, res.response.start);
       },
      error: function(status){
           console.log(status);
      }
  })
}

function filterProducts(products, tag) {
  var filteredProducts = products.filter(function(product){
      return product.tags.indexOf(tag) > -1;
  });

}

function buildPagination(totalProducts, start) {
      var $productPaginationContainer = $('#productPagination');
      $productPaginationContainer.empty();
      const maxPagesToShow = 5;
      var products = [],
      product = {}, 
      data = {}, 
      source = $("#productPaginationTemplate").html(),
      template = Handlebars.compile(source);
      var pagination = {};
      var totalpages = Math.ceil(totalProducts/productPerPage);
      var pages = [];
      if(totalProducts > 0) {
          var currentPage = (start/productPerPage) + 1;
          pagination.nextactive = currentPage > 0 && currentPage < totalpages;
          pagination.prevactive = currentPage > 1;
          pagination.nextPage = currentPage + 1;
          pagination.prevPage = currentPage -1;
          let pagesToShow = maxPagesToShow;
          let startIdex = 1;
          if(totalpages <= maxPagesToShow) {
            pagesToShow = totalpages;
          } else {
            if(currentPage >= maxPagesToShow) {
              startIdex = currentPage-2;
              pagesToShow = currentPage + maxPagesToShow -3;
            } else {
              startIdex = 1;
            }
            if(pagesToShow >= totalpages) {
              pagesToShow = totalpages;
              startIdex = currentPage-(maxPagesToShow - 1);
            }
          }
          for(var i=startIdex; i<=pagesToShow; i++) {
            var page = {};
            page.label = i;
            page.active = (i === currentPage);
            pages.push(page);
          }
      }
      pagination.pages = pages;
      pagination.lastpage = totalpages;
      pagination.firstpage = 1;
      
  data = {
    pagination: pagination
  } 

  $productPaginationContainer.append(template(data));
}

function fetchSearchResults() {
  const filterQuery = formQuery();
  getFilterProducts(filterQuery);
}

function fetchPage(pageNumber) {
  currentstart = (pageNumber - 1) * productPerPage;
  currentrow = productPerPage;
  fetchSearchResults();
  window.scroll({top: 0, left: 0, behavior: 'smooth' });
}

function buildFilteredProducts(filteredProds) {
  var $productContainer = $('#js-product-container');
      
      $productContainer.empty();
      var products = [],
      product = {}, 
      data = {}, 
      source = $("#ProductTemplate").html(),
      template = Handlebars.compile(source);
      products = filteredProds.map(function(productItem) {   
          var uom = 'SF';
          if(productItem['uom'] == null || productItem['uom'] === undefined){
            uom = 'SF';
          }
          else{
            uom = productItem['uom'][0];
          }        
          return product = {
              id: productItem['productId'], 
              //description: productItem.body_html[0].replace(/<\/?[^>]+(>|$)/g, "").split(' ').join(' '), 
              title: productItem['title'],
              color: productItem['color'],
              //price: Shopify.formatMoney(productItem.price[0], {{ shop.money_format | json }})
              showPrice: productItem['available_online'][0] && productItem['price'][0] !== 0, 
              price: productItem['coveragePerBox'] && productItem['coveragePerBox'][0] !== 0 ? (productItem['price'][0]/productItem['coveragePerBox'][0]).toFixed(2) : productItem['price'][0].toFixed(2),
              coveragePerBox: productItem['coveragePerBox'] && productItem['coveragePerBox'][0] !== 0 ? true: false,
              productCalloutTxt: productItem['plpProductCallout'] ? productItem['plpProductCallout'][0] : "",
              showProductCallout: productItem['plpProductCallout'] && productItem['plpProductCallout'][0] !== "",
              url: '/products/' + productItem['handle'],
              imgUrl: productItem['imageUrl'],
              handle: productItem['handle'],
              style: productItem['style'],
              isFav: checkIfFav(productItem['handle']),
              //inventoryTotal: productItem['total_inventory'][0] !== 0 ? formatNumberToString(productItem['total_inventory'][0]) + ' ' + uom + ' Available' : ''
          }
      });
      
  data = {
      product: products
  } 

  $productContainer.append(template(data));
}

function convertToId(value) {
  return value.replace(/ |\/|\.|,/g, '-');
}

function mapFilterHeadings(filterLabel){
  if(filterLabel === "Install Method") {
    return "Installation Method";
  }
  if(filterLabel === "Product Type") {
    return "Product";
  }
  if(filterLabel === "Product Sub Type") {
    return "Type";
  }
  if(filterLabel === "Vendor") {
    return "Brand";
  }
  if(filterLabel === "Total Inventory") {
    return "Inventory";
  }
  if(filterLabel === '[0,999]') {
      return 'Under 999';
  }
  if(filterLabel === '[1000,*]') {
      return '1000 +';
  }
  if(filterLabel === '[3000,*]') {
      return '3000 +';
  }
  if(filterLabel === '[5000,*]') {
      return '5000 +';
  }
  if(filterLabel === '[15,19]') {
      return '15 oz - 19 oz';
  }
  if(filterLabel === '[20,24]') {
      return '20 oz - 24 oz';
  }
  if(filterLabel === '[25,36]') {
      return '25 oz - 36 oz';
  }
  if(filterLabel === '[37,50]') {
      return '37 oz - 50 oz';
  }
  if(filterLabel === '[51,75]') {
      return '51 oz - 75 oz';
  }
  if(filterLabel === '[75,*]') {
      return 'Over 75 oz';
  }
  return filterLabel;
}

function buildFacetForProducts(facetFilters, rangeFilter, totalResultCount) {
  var $productFacetContainer = $('#accordion');
      
      $productFacetContainer.empty();
      var facets = [],
      data = {}, 
      source = $("#ProductFacetTemplate").html(),
      template = Handlebars.compile(source);

      for (var key in facetFilters) {
        var rawfacetOptions = facetFilters[key];
        if (facetFilters.hasOwnProperty(key) && rawfacetOptions.length > 0 && key!=='total_inventory') {
          if(rangeFilter && rangeFilter.hasOwnProperty(key)) {
            var rawRangeOptions = rangeFilter[key];
            var facet = {};
            facet.id = key;
            facet.label = mapFilterHeadings(humanize(key));
            var facetOptions = [];
            Object.keys(rawRangeOptions).forEach(function(key) {
              if(rawRangeOptions[key] > 0) {
                  var facetOption = {};
                  var rangeLabel = mapFilterHeadings(humanize(key));
                  facetOption.id = convertToId(rangeLabel.replace("+", ""));
                  facetOption.value = key.replace(",", " TO ");
                  facetOption.label = rangeLabel;
                  facetOption.count = rawRangeOptions[key];
                  facetOptions.push(facetOption);
              }
            });
            facet.facetOptions = facetOptions;
            if(facetOptions.length > 0) {
              facets.push(facet);
            }
          }else {
            var facet = {};
            facet.id = key;
            facet.label = mapFilterHeadings(humanize(key));
            var facetOptions = [];
            for(var i=0; i < rawfacetOptions.length; i=i+2) {
              var facetOption = {};
              facetOption.id = convertToId(rawfacetOptions[i]);
              facetOption.value = rawfacetOptions[i];
              facetOption.label = humanize(rawfacetOptions[i]);
              facetOption.count = rawfacetOptions[i+1];
              facetOptions.push(facetOption);
              /*if(facetOption.count != totalResultCount) {
                facetOptions.push(facetOption);
              }*/
            }
            facet.facetOptions = facetOptions;
            if(facetOptions.length > 0) {
              facets.push(facet);
            }
          }
        }
      }
      

  data = {
      facets: facets
  } 

  $productFacetContainer.append(template(data));
  populateCheckedFields();
}

function populateCheckedFields() {
var selectedDataFilters = [];
if(selectedFields.size > 0) {
  selectedFields.forEach(function(value, key){
    var selectedDataFilter = {};
    selectedDataFilter.facetId = key;
    selectedDataFilter.id = value[0];
    selectedDataFilter.value = value[1];
    const filterOption = key;
    const filterValues = value;
    $('#' + filterOption).find("#" + filterValues[0]).attr('checked', true);
    selectedDataFilters.push(selectedDataFilter);
  });
}
  populateProductSelectedFacet(selectedDataFilters);
}

function populateProductSelectedFacet(selectedDataFilters) {
var $productSelectedFacetContainer = $('#selectedFilter');
      
      $productSelectedFacetContainer.empty();
      var facets = [],
      data = {}, 
      source = $("#ProductSelectedFacetTemplate").html(),
      template = Handlebars.compile(source);			  
  data = {
      selectedFacets: selectedDataFilters
  } 

  $productSelectedFacetContainer.append(template(data));
}

function reverseObject(obj) {
  var facetReversed = [];
  if(obj.size > 0) {
    obj.forEach(function(value, key){
      var selectedDataFilter = {};
      selectedDataFilter.facetId = key;
      selectedDataFilter.id = value[0];
      selectedDataFilter.value = value[1];
      const filterOption = key;
      const filterValues = value;
      $('#' + filterOption).find("#" + filterValues[0]).attr('checked', true);
      facetReversed.push(selectedDataFilter);
    });
  }
  return facetReversed.reverse();
};

function formQuery() {
var filterQuery = serviceUrl + "/search?q=productEnabled:true AND " + collectioTitle;
let i = 0;
let facetsSelected = false;
$('.facetOptions').each(function(){
  const facetFieldName = $(this).attr('id');
  if($(this).find('input:checkbox:checked').length > 0 ) {
    facetsSelected = true;
    filterQuery = filterQuery + ' AND ';
    i = i +1;
    var facetOptionArray = [];
    var facetValueLength = $(this).find('input:checkbox:checked').length;
    $(this).find('input:checkbox:checked').each(function(j){
        const facetValue = $(this).attr('value');
        const facetId = $(this).attr('id');
        if(facetValue.indexOf('[') !== -1) {
            filterQuery = filterQuery + facetFieldName + ':' + facetValue;
        } else {
            if(j === 0) {
              filterQuery = filterQuery + facetFieldName + ':("' + facetValue + '"';
            } else {
              filterQuery = filterQuery + ' OR "' + facetValue + '"';
            }
            if(facetValueLength === j + 1) {
              filterQuery = filterQuery + ")";
            }
        }
        facetOptionArray.push(facetId);
        facetOptionArray.push(facetValue);
    });
    selectedFields.set(facetFieldName, facetOptionArray);
  } else {
    selectedFields.delete(facetFieldName);
  }
});
filterQuery = filterQuery +"&start="+ currentstart+ "&rows=" + currentrows;
if(sortOption !== "") {
  filterQuery = filterQuery + "&sort=" + sortOption;
}
return filterQuery + "&facet.sort=index";
}

function filterResults(){
currentrows = productPerPage;
currentstart = 0;
if($('input:checkbox:checked').length === 0) {
  selectedFields.clear();
  getFilterProducts(baseProductUrl);
} else {
  fetchSearchResults();
}
}

function removeFilter(filterId, facetId) {
$('#' + facetId).find("#" + filterId).attr('checked', false);
filterResults();
}

function toggleFav(productData) {
  if(productData.isFav) {
    removeFav(productData);
  } else {
    addFav(productData);
  }
  buildFilteredProducts(filteredResults);
  checkAnUpdateFavStar();
}

$(document).ready(function(){

  //var baseProductUrl = "{{ 'products.json' | asset_url }}";
  //var filterProductUrl = "{{ 'product-filtered.json' | asset_url }}";
  getFilterProducts(baseProductUrl);

});
